import styled, { css } from "styled-components";
import { IStyleProps } from "./interfaces";

export const Score = styled.div`
    display: inline-block;
    overflow: hidden;
    transform-origin: top left;
    img {
        pointer-events: none;
        user-select: none;
    }
`;

export const ScoreWrapper = styled.div<IStyleProps>`
    position: absolute;
    ${p =>
        p.isLow &&
        css`
            background-color: white;
            box-shadow: 0 0 0 3px black;
            border-radius: 38px;
            -webkit-mask-image: -webkit-radial-gradient(white, black);
        `}
    transform-origin: top left;

    overflow: hidden;
`;

const HideOnComplete = css`
    &.HideOnComplete {
        transition: 1s;
        opacity: 0;
        pointer-events: none;
    }
`;

export const Drop = styled.div`
    position: absolute;

    border-radius: 20px;
    box-shadow: none;
    border: 3px solid black;
    box-sizing: border-box;
    background-color: white;
    &.Christmas {
        border: 5px solid ${p => p.theme.c.christmasBlue};
        border-radius: 0;
        box-shadow: 0 0 0 1px #666;
    }
    &.Active {
        background-color: #ddd;
    }

    ${HideOnComplete}
`;

export const Drag = styled.div`
    overflow: hidden;
    cursor: pointer;
    position: relative;
    transition: background-color 0.3s;
    box-shadow: 0 0 0 3px black inset;
    border-radius: 20px;

    &.Christmas {
        background-color: ${p => p.theme.c.christmasBlue};
        border-radius: 0;
        box-shadow: 0 0 0 3px ${p => p.theme.c.christmasLightBlue} inset;

    }

    img {
        background-color: ${p => p.theme.c.white};
        mix-blend-mode: multiply;
    }
    &.Correct {
        background-color: ${p => p.theme.c.correct} !important;
    }

    &.Incorrect {
        background-color: ${p => p.theme.c.incorrect} !important;
    }

    ${HideOnComplete}
`;

export const Playground = styled.div<IStyleProps>`
    ${p =>
        p.isLow &&
        css`
            transform: scale(0.55);
            margin-top: 120px;
        `}
`;

export const Asset1Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    pointer-events: none;

    img {
        width: 1280px;
    }
`;
